import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import folderStore, { onCreateNewFolderInboxRulesResponse } from 'owa-folders';
import { createNewFolderService } from 'owa-folders';

export default function createNewFolder(
    displayName: string,
    parentFolderId: string
): Promise<string> {
    displayName = (displayName || '').trim(); // Do not allow whitespaces.

    return createNewFolderService(parentFolderId, displayName).then(
        (responseMessage: FolderInfoResponseMessage) => {
            if (responseMessage.ResponseClass === 'Success') {
                onCreateNewFolderInboxRulesResponse(
                    folderStore,
                    responseMessage.Folders[0],
                    parentFolderId,
                    displayName
                );
                return responseMessage.Folders[0].FolderId.Id;
            } else {
                throw new Error(responseMessage.MessageText);
            }
        }
    );
}
